module.exports = __webpack_public_path__ + "static/media/7_l_katushka_10.94_73.06.5963f19f.png";